import { Card, CardContent } from '@mlm/ui';
import type { MonthlyPvBucket } from '../../lib/api';
import { fmtNumber } from '../../lib/format';

/** "2026-06" → "Jun 2026" for a compact, friendly month label. */
function fmtMonth(month: string): string {
  const [y, m] = month.split('-');
  const date = new Date(Number(y), Number(m) - 1, 1);
  return date.toLocaleDateString(undefined, { month: 'short', year: 'numeric' });
}

/**
 * Per-month PPV (and optionally GPV) the member has accumulated, summed from the
 * points history. Gated upstream by the tenant `member_pv_display` policy; this
 * panel only renders when there is something to show. Styled to sit quietly in
 * the dashboard left rail beside the wallet + standing panels.
 */
export function PvMonthlyPanel({
  buckets,
  showGpv,
}: {
  buckets: MonthlyPvBucket[];
  showGpv: boolean;
}) {
  if (buckets.length === 0) return null;
  return (
    <Card>
      <CardContent className="p-6">
        <p className="text-caption font-medium uppercase tracking-[0.1em] text-muted-foreground">
          PV by month
        </p>
        <div className="mt-3 overflow-hidden">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-caption text-muted-foreground">
                <th className="pb-2 text-left font-normal">Month</th>
                <th className="pb-2 text-right font-normal">Personal</th>
                {showGpv && <th className="pb-2 text-right font-normal">Group</th>}
              </tr>
            </thead>
            <tbody>
              {buckets.map((b) => (
                <tr key={b.month} className="border-t border-border/60">
                  <td className="py-2 text-left">{fmtMonth(b.month)}</td>
                  <td className="py-2 text-right tabular-nums">{fmtNumber(b.ppv)}</td>
                  {showGpv && (
                    <td className="py-2 text-right tabular-nums">
                      {b.gpv != null ? fmtNumber(b.gpv) : '—'}
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
}
